/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DashboardKpiBreakdownItemDto } from './DashboardKpiBreakdownItemDto';
import type { DashboardKpiTrendDto } from './DashboardKpiTrendDto';
export type DashboardKpiItemDto = {
    id: string;
    title: string;
    value: number;
    format: DashboardKpiItemDto.format;
    trend?: DashboardKpiTrendDto;
    breakdown?: Array<DashboardKpiBreakdownItemDto>;
};
export namespace DashboardKpiItemDto {
    export enum format {
        CURRENCY = 'currency',
        NUMBER = 'number',
        BREAKDOWN = 'breakdown',
    }
}

